import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SMLogo(props: { className?: string }) {
    const { t } = useTranslation();
    return (
        <Link
            to={'/'}
            className={`whitespace-nowrap font-montserrat text-lg font-medium uppercase tracking-[.06em] ${props.className}`}>
            {t('SM')}
        </Link>
    );
}

export function SMLogoUnderlined(props: { className?: string }) {
    const { t } = useTranslation();
    return (
        <Link
            to={'/'}
            className={`flex w-fit flex-col items-center whitespace-nowrap font-montserrat text-lg font-medium uppercase tracking-[.06em] text-SM-dark ${props.className}`}>
            {t('SM')}
            <div className={'ml-auto mr-auto h-1 w-1/2 rounded-full bg-SM-yellow'} />
        </Link>
    );
}

export function SMAdminCenterLogo(props: { className?: string }) {
    const { t } = useTranslation();
    return (
        <Link
            to={'/adminCenter'}
            className={`flex w-fit flex-col items-center text-SM-dark ${props.className}`}>
            <span
                className={
                    'whitespace-nowrap font-montserrat text-lg font-medium uppercase tracking-[.06em]'
                }>
                {t('SM')}
            </span>
            <div className={'ml-auto mr-auto h-1 w-1/2 rounded-full bg-SM-yellow'} />
            <span
                className={
                    'mt-1 font-montserrat text-xs font-medium uppercase tracking-[.06em] text-SM-dark'
                }>
                Admin Center
            </span>
        </Link>
    );
}
